import { useState } from 'react';
// @mui
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';

import StepTitle from './step-title';

// ----------------------------------------------------------------------

const QUARTERS = [
  { value: 'Q1', label: 'Q1', months: 'Jan – Mar' },
  { value: 'Q2', label: 'Q2', months: 'Apr – Jun' },
  { value: 'Q3', label: 'Q3', months: 'Jul – Sep' },
  { value: 'Q4', label: 'Q4', months: 'Oct – Dec' },
];

type Props = {
  onBack?: () => void;
  initialQuarter: string;
  saving: boolean;
  onSave: (quarter: string) => void;
};

export default function StepPeriod({ initialQuarter, saving, onSave, onBack }: Props) {
  const currentYear = new Date().getFullYear();
  const years = [currentYear, currentYear - 1, currentYear - 2];

  const [year, setYear] = useState(initialQuarter ? initialQuarter.split(' ')[0] : String(currentYear));
  const [quarter, setQuarter] = useState(initialQuarter ? initialQuarter.split(' ')[1] : '');

  return (
    <Stack spacing={3}>
      <StepTitle title="Which period are you filing for?" onBack={onBack} />

      <TextField
        select
        label="Year"
        value={year}
        onChange={(event) => setYear(event.target.value)}
        sx={{ maxWidth: 200 }}
        data-testid="period-year-select"
      >
        {years.map((y) => (
          <MenuItem key={y} value={String(y)}>
            {y}
          </MenuItem>
        ))}
      </TextField>

      <Grid container spacing={2}>
        {QUARTERS.map((q) => (
          <Grid item xs={6} sm={3} key={q.value}>
            <Card
              variant="outlined"
              sx={{
                borderColor: quarter === q.value ? 'primary.dark' : 'divider',
                borderWidth: 2,
              }}
            >
              <CardActionArea
                onClick={() => setQuarter(q.value)}
                sx={{ p: 2, textAlign: 'center' }}
                data-testid={`quarter-${q.value}`}
              >
                <Typography variant="h4">{q.label}</Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary' }}>
                  {q.months}
                </Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      <Button
        variant="contained"
        color="secondary"
        size="large"
        disabled={!quarter || saving}
        onClick={() => onSave(`${year} ${quarter}`)}
        sx={{ alignSelf: 'flex-start' }}
        data-testid="period-continue"
      >
        Continue
      </Button>
    </Stack>
  );
}
